import React from 'react'
import { Link, StaticQuery, graphql } from 'gatsby'
import Button from "./Button";
import Img from "gatsby-image"
import styled from "styled-components"

const Tags = ({post}) => {
    if(post.frontmatter.tags){
    const listTags = post.frontmatter.tags.map((tag,index) =>    <li key={index} className="tag">{tag}</li>  );
      return(
        <ul className="listTags">
          {listTags}
        </ul>
      )
    }
}

const New = () =>{
  return(
    <button className="new">
      new
    </button>
  )
}

const Post = ({post}) => {
  const temps_reference = 602297097 //correspond a 1 semaine en millisecondes
  let date_publication = Date.parse(post.frontmatter.date);// millisecondes entre le 1 janv 1970 et la date de publication
  let aujourdhui = Date.now();// millisecondes entre le 1er janv 1970 et maintenant 
  let temps_ecoule = aujourdhui - date_publication;// temps ecoule entre maintenant et la date de publication en millisecondes


    return (
        <div className="is-parent column is-6"  >
          <aside>
            <img src={post.frontmatter.thumbnail} alt={post.frontmatter.title} />
          </aside>
          <article
            className={`blog-list-item tile is-child box notification ${
              post.frontmatter.featuredpost ? 'is-featured' : ''
            }`}
          >
            <div className="index-header">
              <p className="post-meta">
              {(temps_ecoule <= temps_reference) && <New />}
                <Link
                  className="title has-text-primary is-size-4"
                  to={post.frontmatter.path}
                >
                  {post.frontmatter.title}
                </Link>
                <span> &bull; </span>
                <span className="subtitle is-size-5 is-block">
                  {post.frontmatter.date}
                </span>
                <span> &bull; </span>
              <span> {post.fields.readingTime.text}</span>
              </p>
            </div>
            {post.frontmatter.tags && <Tags post={post}/>}
            <p>
              {post.excerpt.length <400 ? post.excerpt+"...": post.excerpt}
            </p>
            <Link className="buttonLecture" to={post.frontmatter.path}>
              <Button label="Continuer la lecture →" ></Button>
            </Link>
          </article>
        </div>
      )

}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #27292c;
  margin: 20px 0;
  overflow: hidden;
  width: 100%;
  height: 300px;
  @media screen and (max-width: 681px){
    .column{
      grid-template-columns: 1fr ;
      height: auto;
      padding: 20px;
    }
  }
  aside {
    margin-right: 20px;
    img{
      width: 100%;
      height: 300px;
    }
    @media screen and (max-width: 681px){
        grid-template-columns: 1fr ;
        height: auto;
        padding: 20px;
  }
  article{
    position: relative;
    .buttonLecture{
      position: absolute;
      bottom: 20%;
    }
  }
`

export default Post;